function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M.8 2.5c-.5 0-.8-.6-.8-1.3S.3 0 .8 0h13.4c.4 0 .8.6.8 1.2s-.4 1.2-.8 1.2H.8z"
});

var SvgIconMinus = function SvgIconMinus(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 15 2.5"
  }, props), _ref);
};

export default "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 22.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='icon-minus' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 15 2.5' enable-background='new 0 0 15 2.5' xml:space='preserve'%3E %3Cpath id='minus' d='M0.8,2.5C0.3,2.5,0,1.9,0,1.2S0.3,0,0.8,0h13.4C14.6,0,15,0.6,15,1.2s-0.4,1.2-0.8,1.2H0.8z'/%3E %3C/svg%3E";
export { SvgIconMinus as ReactComponent };